// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__wQzWm","tab":"ProcedureTabs_tab__2GQqF"};